import jwt from 'jsonwebtoken'
import { getQueryString } from 'lib/util';
import cache from "memory-cache";

export const getHistoryAndLegacy = async (total = 4) => {
    const token = jwt.sign({iss: 'get_history'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const url = `/api/jtsHistoryLegacy?token=${token}&total=${total}`
    const response = await fetch(url);
    const data = await response.json();
    const items = data?.data?.datas || []
    return items
}

export const getHistoryAndLegacyServer = async (total = 4) => {
    const host = process.env.HOST;
    const token = jwt.sign({iss: 'get_history'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const url = `${host}/api/jtsHistoryLegacy?token=${token}&total=${total}`
    const response = await fetch(url);
    const data = await response.json();
    const items = data?.data?.datas || []
    return items
}

export const getCorpporateInfomation = async () => {
    const host = process.env.HOST;
    const token = jwt.sign({iss: 'get_corporate_infomations'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const url = `${host}/api/jtsCorporateInfomation?token=${token}`
    const response = await fetch(url);
    const data = await response.json();
    const items = data?.data?.datas || []
    return items
}

export const getStockPrice = async () => {
    const url = `/api/financial`
    let items = {}
    try {
      const response = await fetch(url);
      const data = await response.json();
      items = data?.data?.data || {}
    } catch (e) {
      console.log(`[files][getStockPrice] Failed to query data: ${e.message}`);
    }
    return items
}

export const getBtcPrice = async () => {
    const cacheKey = `btc:price`
    const url = `/api/getBtcPrice`
    const cachedResponse = cache.get(cacheKey)
    if (!cachedResponse) {
        const minutes = 60 * 60 * 1000
        const response = await fetch(url);
        const data = await response.json();
        let items = data?.data?.data || {}
        if (Object.keys(items).length === 0) {
            return items
        } else {
            cache.put(cacheKey, items, minutes);
            return items
        }
    } else {
        return cachedResponse
    }
}

export const getDownloadFileList = async (folder_name, year = null, kw = null) => {
    const token = jwt.sign({iss: 'open_folder'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const apiHost = new URL(process.env.WORDPRESS_GRAPHQL_ENDPOINT).host;
    let queryString = getQueryString({ folder_name, token, kw, year }, true)
    let data = []
    try {
      const res = await fetch(`https://${apiHost}?rest_route=/v1/list/files&${queryString}`)
      data = await res.json()
      data = data?.data || []
    } catch (e) {
      console.log(`[files][getlist] Failed to query data: ${e.message}`);
    }
    return data
}

export const getEgmGroupDownloadFileV3 = async (post_id) => {
    const apiHost = new URL(process.env.WORDPRESS_GRAPHQL_ENDPOINT).host;
    let queryString = getQueryString({ post_id }, true)
    let data = []
    try {
      const res = await fetch(`https://${apiHost}?rest_route=/v1/egm-group/download-v3&${queryString}`)
      data = await res.json()
      data = data?.data || []
    } catch (e) {
      console.log(`[downloadV3][egmGroupList] Failed to query data: ${e.message}`);
    }
    return data
}


export const getDownloadV3UseTemplateList = async (lang) => {
    const apiHost = new URL(process.env.WORDPRESS_GRAPHQL_ENDPOINT).host;
    let queryString = getQueryString({ locale: lang, template: 'template-download-v3' }, true)
    let data = []
    try {
      const res = await fetch(`https://${apiHost}?rest_route=/v1/page-use-template/download-v3&${queryString}`)
      data = await res.json()
      data = data?.data || []
    } catch (e) {
      console.log(`[jts][downloadV3UseTemplate] Failed to query data: ${e.message}`);
    }
    return data
}

export const getDownloadV3Years = async (lang) => {
  const apiHost = new URL(process.env.WORDPRESS_GRAPHQL_ENDPOINT).host;
  let queryString = getQueryString({ locale: lang }, true);
  let data = [];
  try {
    const res = await fetch(
      `https://${apiHost}?rest_route=/v1/years/download-v3&${queryString}`
    );
    data = await res.json();
    data = data?.data || [];
  } catch (e) {
    console.log(`[jts][downloadV3Years] Failed to query data: ${e.message}`);
  }
  return data;
};

export const getDownloadV3PageByYear = async (lang, year) => {
  const url = `/api/getDownloadV3PageByYear?locale=${lang}&year=${year}`
  const response = await fetch(url);
  const data = await response.json();
  let item = data?.data?.datas?.item?.data || {}
  return item
};

export const getInvestorRelationsServer = async () => {
    const host = process.env.HOST;
    const token = jwt.sign({iss: 'get_investor_relations'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const url = `${host}/api/jtsInvestorRelations?token=${token}`
    const response = await fetch(url);
    const data = await response.json();
    let items = data?.data?.data || []
    return items
}

export const getInvestorRelations = async () => {
    const token = jwt.sign({iss: 'get_investor_relations'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const cacheKey = `investor:relation`
    const url = `/api/jtsInvestorRelations?token=${token}`
    const cachedResponse = cache.get(cacheKey)
    if (!cachedResponse) {
        const minutes = 5 * 60 * 1000
        const response = await fetch(url);
        const data = await response.json();
        let items = data?.data?.data || []
        if (items.length === 0) {
            return items
        } else {
            cache.put(cacheKey, items, minutes);
            return items
        }
    } else {
        return cachedResponse
    }
}

export const getDraftPageById = async (id) => {
    const host = process.env.HOST;
    const token = jwt.sign({iss: 'is_openned'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const res = await fetch(`${host}/api/getDraftPageById?id=${id}&token=${token}`)
    const data = await res.json()
    return data?.data?.data || {}
}

export const getDraftPostById = async (id) => {
    const host = process.env.HOST;
    const token = jwt.sign({iss: 'is_openned'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const res = await fetch(`${host}/api/getDraftPostById?id=${id}&token=${token}`)
    const data = await res.json()
    return data?.data?.data || {}
}

export const getMenuBylocation = async (lang, location) => {
    const token = jwt.sign({iss: 'get_menus'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const res = await fetch(`/api/getMenuBylocation?lang=${lang}&location=${location}&token=${token}`)
    const data = await res.json()
    return data?.data?.datas || []
}

export const getMenuBylocationV2 = async (lang, location) => {
    let items = []
    try {
        const res = await fetch(`/api/getMenuBylocation?lang=${lang}&location=${location}`)
        const data = await res.json()
        items = data?.data?.datas || []
    } catch (e) {
        console.log(`[menus][getMenuBylocationV2] Failed to query data: ${e.message}`);
    }

    return items
}

export const getShareholders = async () => {
    const token = jwt.sign({iss: 'get_shareholders'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const res = await fetch(`/api/jtsShareholders?token=${token}`)
    const data = await res.json()
    return data?.data?.data || {}
}

export const getShareholdersServer = async () => {
    const host = process.env.HOST;
    const token = jwt.sign({iss: 'get_shareholders'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const res = await fetch(`${host}/api/jtsShareholders?token=${token}`)
    const data = await res.json()
    return data?.data?.data || {}
}

export const sendEmail = async (email, issue) => {
    const token = jwt.sign({iss: issue}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const res = await fetch(`/api/sendEmail`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            email,
            token
        })
    })
    const data = await res.json()
    return data
}

export const getLatestSplash = async () => {
    const apiHost = new URL(process.env.WORDPRESS_GRAPHQL_ENDPOINT).host;
    let data = null
    try {
      const res = await fetch(`https://${apiHost}?rest_route=/v1/splash/latest`)
      data = await res.json()
    } catch (e) {
      console.log(`[splash][getLatestSplash] Failed to query data: ${e.message}`);
    }

    return data?.data || null
}

export const getLatestPopup = async () => {
    const host = process.env.HOST;
    const url = `${host}/api/jtsLatestPopup`
    const response = await fetch(url);
    const data = await response.json();
    let items = data?.data?.data || null
    return items
}


export const getFinancialHighlight = async (year = null) => {
    const host = process.env.HOST;
    const token = jwt.sign({iss: 'get_financial_highlight'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const query = getQueryString({token})
    const url = `${host}/api/jtsFinancialHighlight${query}`
    const response = await fetch(url);
    const data = await response.json();
    let items = data?.data?.data || []
    return items
}

export const getFinancialHighlightGorssaries = async () => {
    const host = process.env.HOST;
    const token = jwt.sign({iss: 'get_financial_highlight_grossaries'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const query = getQueryString({token})
    const url = `${host}/api/jtsFinancialHighlightGrossary${query}`
    const response = await fetch(url);
    const data = await response.json();
    let items = data?.data?.data || []
    return items
}

export const getFinancialHighlightYear = async () => {
    const host = process.env.HOST;
    const token = jwt.sign({iss: 'get_year_financial_highlight'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const query = getQueryString({token})
    const url = `${host}/api/jtsFinancialHighlightYear${query}`
    const response = await fetch(url);
    const data = await response.json();
    let items = data?.data?.data || []
    return items
}

export const getQuarterlyReport = async (year = null, is_client = false) => {
    const currentYear = year === null ? new Date().getFullYear() : year
    const host = is_client ? '' : process.env.HOST;
    const token = jwt.sign({iss: 'get_quarterly_report'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const query = getQueryString({token, year: currentYear})
    const url = `${host}/api/jtsQuarterlyReport${query}`
    const response = await fetch(url);
    const data = await response.json();
    let items = data?.data?.data || []
    return items
}

export const getGrossaryQuarterlyReport = async (year = null, is_client = false) => {
    const currentYear = year === null ? new Date().getFullYear() : year
    const host = is_client ? '' : process.env.HOST;
    const token = jwt.sign({iss: 'get_grossary_quarterly_report'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const query = getQueryString({token, year: currentYear})
    const url = `${host}/api/jtsQuarterlyReportGrossary${query}`
    const response = await fetch(url);
    const data = await response.json();
    let items = data?.data?.data || []
    return items
}

export const getQuarterlyReportYear = async () => {
    const host = process.env.HOST;
    const token = jwt.sign({iss: 'get_quarterly_report_years'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const query = getQueryString({token})
    const url = `${host}/api/jtsQuarterlyReportYear${query}`
    const response = await fetch(url);
    const data = await response.json();
    let items = data?.data?.data || []
    return items
}

export const getBoardOfDirector = async (is_client = false) => {
    const host = is_client ? '' : process.env.HOST;
    const token = jwt.sign({iss: 'get_board_director'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const query = getQueryString({ token })
    const url = `${host}/api/jtsBoardOfDirector${query}`
    const response = await fetch(url);
    const res = await response.json();
    let item = res?.data?.data || {}
    return item
}

export const getExecutive= async (is_client = false) => {
    const host = is_client ? '' : process.env.HOST;
    const token = jwt.sign({iss: 'get_executive'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const query = getQueryString({ token })
    const url = `${host}/api/jtsExecutive${query}`
    const response = await fetch(url);
    const res = await response.json();
    let item = res?.data?.data || {}
    return item
}

export const getOperationalHighlight = async () => {
    const token = jwt.sign({iss: 'get_operational_highlight'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const apiHost = new URL(process.env.WORDPRESS_GRAPHQL_ENDPOINT).host;
    let items = []
    try {
        const res = await fetch(`https://${apiHost}?rest_route=/v1/jts-operational-highlights/list-frontend&token=${token}`)
        const data = await res.json()
        items = data?.data || []
        if (items.length > 0) {
            items = items.map(item => {
                return {
                    ...item,
                    content: JSON.parse(item.content)
                }
            })
        }
    } catch (e) {
        console.log(`[jts][getOperationalHighlight] Failed to query data: ${e.message}`);
    }

    return items
}

export const getShowUi = async () => {
    const token = jwt.sign({iss: 'get_show_ui'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const apiHost = new URL(process.env.WORDPRESS_GRAPHQL_ENDPOINT).host;
    let items = []
    try {
        const res = await fetch(`https://${apiHost}?rest_route=/v1/jts-show-ui/get-section-is-show&token=${token}`)
        const data = await res.json()
        items = data?.data || []
    } catch (e) {
        console.log(`[jts][getShowUi] Failed to query data: ${e.message}`);
    }
    return items
}


export const getAllCustomPostType = async (post_type, locale, show = 5, kw = null, year = null) => {
    const token = jwt.sign({iss: 'get_custom_post_type'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const apiHost = new URL(process.env.WORDPRESS_GRAPHQL_ENDPOINT).host;
    let items = []
    try {
        const res = await fetch(`https://${apiHost}?rest_route=/v1/custom-post-type/&token=${token}&locale=${locale}&post_type=${post_type}&show=${show}`)
        const data = await res.json()
        if (post_type === 'news') {
            items = {
                items: data?.data || [],
                home_news_data: data?.home_news_data || {}
            }
        } else {
            items = data?.data || []
        }
    } catch (e) {
        console.log(`[jts][getCustomPostType] Failed to query data: ${e.message}`);

    }

    return items
}

export const customPostTypeYear = async (post_type, locale) => {
    const token = jwt.sign({iss: 'get_custom_post_type_year'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const apiHost = new URL(process.env.WORDPRESS_GRAPHQL_ENDPOINT).host;
    let items = []
    try {
        const res = await fetch(`https://${apiHost}?rest_route=/v1/custom-post-type/years/&token=${token}&post_type=${post_type}&locale=${locale}`)
        const data = await res.json()
        items = data?.data || []
    } catch (e) {
        console.log(`[jts][jtsCustomPostTypeyear] Failed to query data: ${e.message}`);
    }

    return items
}

export const customPostTypeExists = async (post_type) => {
    const token = jwt.sign({iss: 'get_custom_post_type_exists'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const apiHost = new URL(process.env.WORDPRESS_GRAPHQL_ENDPOINT).host;
    let item = false
    try {
        const res = await fetch(`https://${apiHost}?rest_route=/v1/custom-post-type/exists/&token=${token}&post_type=${post_type}`)
        const data = await res.json()
        item = data?.data || false
    } catch (e) {
        console.log(`[jts][jtsCustomPostTypeExists] Failed to query data: ${e.message}`);
    }
    return item
}

export const getAllPostsByCategorySlug = async (category_slug, locale, show = 'all') => {
    const token = jwt.sign({iss: 'get_post_by_category_slug'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const apiHost = new URL(process.env.WORDPRESS_GRAPHQL_ENDPOINT).host;
    let items = []
    try {
        const res = await fetch(`https://${apiHost}?rest_route=/v1/category/posts&token=${token}&locale=${locale}&category_slug=${category_slug}&show=${show}`)
        const data = await res.json()
        items = data?.data || []
    } catch (e) {
        console.log(`[jts][jtsPostsByCategoryName] Failed to query data: ${e.message}`);

    }
    return items
}

export const getPostsYearByCategorySlug = async (category_slug, locale, show = 'all') => {
    const token = jwt.sign({iss: 'get_post_year_by_category_slug'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const apiHost = new URL(process.env.WORDPRESS_GRAPHQL_ENDPOINT).host;
    let items = []
    try {
        const res = await fetch(`https://${apiHost}?rest_route=/v1/category/posts/year&token=${token}&locale=${locale}&category_slug=${category_slug}&show=${show}`)
        const data = await res.json()
        items = data?.data || []
    } catch (e) {
        console.log(`[jts][jtsPostsYearByCategoryName] Failed to query data: ${e.message}`);
    }
    return items
}

export const getCorpporateGovPolicyItems = async () => {
    const token = jwt.sign({iss: 'get_cop_gov_policy_items'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const apiHost = new URL(process.env.WORDPRESS_GRAPHQL_ENDPOINT).host;
    let items = []
    try {
        const res = await fetch(`https://${apiHost}?rest_route=/v1/jts-corporate-gov-policy/list-frontend/&token=${token}`)
        const data = await res.json()
        items = data?.data || []
    } catch (e) {
        console.log(`[jts][jtsCorpporateGovPolicyItemsExists] Failed to query data: ${e.message}`);
    }

    return items
}

export const getPdpa = async () => {
    const token = jwt.sign({iss: 'get_pdpa'}, process.env.WORDPRESS_NONCE_SALT, { expiresIn: '7d' });
    const apiHost = new URL(process.env.WORDPRESS_GRAPHQL_ENDPOINT).host;
    let items = []
    try {
        const res = await fetch(`https://${apiHost}?rest_route=/v1/jts-pdpa/list-frontend/&token=${token}`)
        const data = await res.json()
        items = data?.data || []
    } catch (e) {
        console.log(`[jts][jtsCorpporateGovPolicyItemsExists] Failed to query data: ${e.message}`);
    }

    return items
}